module.exports = __webpack_public_path__ + "img/tvhelper_pic_02.206476ab.png";